import React, { useEffect, useState, useRef } from "react";
import {
  Grid, Paper, Typography, Divider, Box, Chip, CircularProgress,
  IconButton, Button, MenuItem, Select, FormControl, InputLabel,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Tooltip,
  Switch, FormControlLabel, ToggleButton, ToggleButtonGroup,
  Stepper, Step, StepLabel, Autocomplete,
} from "@mui/material";
import CIE10 from "../../data/cie10";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddIcon from "@mui/icons-material/Add";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { instance } from "../../axios";
import { toast } from "react-toastify";
import AntecedentesOcupacionales from "./AntecedentesOcupacionales";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { fmtDt } from "../../utils/date";

const outcomeLabels = {
  apto: { label: "Apto", color: "success" },
  apto_con_restricciones: { label: "Apto con restricciones", color: "warning" },
  no_apto: { label: "No apto", color: "error" },
  en_espera: { label: "En espera", color: "default" },
  diferido: { label: "Diferido", color: "default" },
};

const InfoRow = ({ label, value }) =>
  value != null && value !== "" ? (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body2">{value}</Typography>
    </Box>
  ) : null;

const VisitDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const antRef = useRef();
  const attachmentInputRef = useRef();
  const currentUser = useSelector((state) => state.user.user);

  const [visit, setVisit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(false);

  // ── Card gauche : fecha + évaluation ───────────────────────
  const [editingLeft, setEditingLeft] = useState(false);
  const [savingLeft, setSavingLeft] = useState(false);
  const [visitDate, setVisitDate] = useState(null);
  const [evalEnabled, setEvalEnabled] = useState(false);
  const [evalType, setEvalType] = useState("");
  const [evalOutcome, setEvalOutcome] = useState("");
  const [evalNotes, setEvalNotes] = useState("");

  // ── Datos laborales ─────────────────────────────────────────
  const [companyId, setCompanyId] = useState("");
  const [cargo, setCargo] = useState("");
  const [dependencia, setDependencia] = useState("");
  const [tipoTrabajador, setTipoTrabajador] = useState("");
  const [companies, setCompanies] = useState([]);

  // ── Motivo / Enfermedad actual ───────────────────────────────
  const [motivoConsulta, setMotivoConsulta] = useState("");
  const [enfermedadActual, setEnfermedadActual] = useState("");

  // ── Card signos vitales ─────────────────────────────────────
  const [editingVitales, setEditingVitales] = useState(false);
  const [savingVitales, setSavingVitales] = useState(false);
  const [taSistolica, setTaSistolica] = useState("");
  const [taDiastolica, setTaDiastolica] = useState("");
  const [pulso, setPulso] = useState("");
  const [peso, setPeso] = useState("");
  const [talla, setTalla] = useState("");
  const [temperatura, setTemperatura] = useState("");

  // ── Examen físico ────────────────────────────────────────────
  const [usaLentes, setUsaLentes] = useState(null);
  const [piel, setPiel] = useState("");
  const [cabezaCuello, setCabezaCuello] = useState("");
  const [ojos, setOjos] = useState("");
  const [orl, setOrl] = useState("");
  const [extremidadesSuperiores, setExtremidadesSuperiores] = useState("");
  const [linfaticos, setLinfaticos] = useState("");
  const [toraxMamas, setToraxMamas] = useState("");
  const [pulmonar, setPulmonar] = useState("");
  const [cardiovascular, setCardiovascular] = useState("");
  const [abdomen, setAbdomen] = useState("");
  const [columnaVertebral, setColumnaVertebral] = useState("");
  const [zonaInguinoGenital, setZonaInguinoGenital] = useState("");
  const [extremidadesInferiores, setExtremidadesInferiores] = useState("");
  const [neurologico, setNeurologico] = useState("");
  const [sensibilidadReflejos, setSensibilidadReflejos] = useState("");

  // ── Card diagnóstico ─────────────────────────────────────────
  const [editingDiag, setEditingDiag] = useState(false);
  const [savingDiag, setSavingDiag] = useState(false);
  const [loadingPrevDiag, setLoadingPrevDiag] = useState(false);
  const [diagnostico, setDiagnostico] = useState([]);
  const [otroDiagnostico, setOtroDiagnostico] = useState("");

  // ── Card prescripción de exámenes ────────────────────────────
  const [editingPrescripcion, setEditingPrescripcion] = useState(false);
  const [savingPrescripcion, setSavingPrescripcion] = useState(false);
  const [prescripcionExamenes, setPrescripcionExamenes] = useState("");

  // ── Card antécédentes ─────��─────────────────────────────────
  const [editingAnt, setEditingAnt] = useState(false);
  const [savingAnt, setSavingAnt] = useState(false);

  // ── Card reposo médico ─────────────────────────────────
  const [editingSusp, setEditingSusp] = useState(false);
  const [savingSusp, setSavingSusp] = useState(false);
  const [suspEnabled, setSuspEnabled] = useState(false);
  const [suspDesde, setSuspDesde] = useState(null);
  const [suspHasta, setSuspHasta] = useState(null);
  const [suspDebeVolver, setSuspDebeVolver] = useState(true);
  const [suspTipoReposo, setSuspTipoReposo] = useState("EC");
  const [suspModalidad, setSuspModalidad] = useState("ambulatorio");
  const [suspTipo, setSuspTipo] = useState("primero");
  const [suspComienzo, setSuspComienzo] = useState(null);
  const [suspMatInicioPrenatal, setSuspMatInicioPrenatal] = useState(null);
  const [suspMatFinPrenatal, setSuspMatFinPrenatal] = useState(null);
  const [suspMatInicioPostnatal, setSuspMatInicioPostnatal] = useState(null);
  const [suspMatFinPostnatal, setSuspMatFinPostnatal] = useState(null);
  const [suspObservacion, setSuspObservacion] = useState("");

  // ── Génération constancia PDF ────────────────────────────────
  const [generating, setGenerating] = useState(false);
  const [generatingSusp, setGeneratingSusp] = useState(false);
  const [generatingReport, setGeneratingReport] = useState(false);
  const [signingVisit, setSigningVisit] = useState(false);
  const [confirmSign, setConfirmSign] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(null); // "eval" | "reposo" | "historico"
  const [uploadingAttachment, setUploadingAttachment] = useState(false);
  const [deletingAttachment, setDeletingAttachment] = useState(null);

  const handleDownloadPdf = async (filename, key) => {
    setDownloadingPdf(key);
    try {
      const dlRes = await instance.get(`/visit/constancia/${filename}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([dlRes.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading PDF:", err);
    } finally {
      setDownloadingPdf(null);
    }
  };

  const handleGenerateReport = async () => {
    setGeneratingReport(true);
    try {
      const res = await instance.post(`/visit/${id}/report`);
      setVisit(res.data);
      if (res.data.historicoFilename) {
        toast.success("Informe de visita generado");
        await handleDownloadPdf(res.data.historicoFilename, "historico");
      }
    } catch (err) {
      console.error("Error generating report:", err);
    } finally {
      setGeneratingReport(false);
    }
  };

  const handleSign = async () => {
    setSigningVisit(true);
    try {
      await instance.post(`/visit/${id}/sign`);
      setVisit((prev) => ({ ...prev, status: "signed" }));
    } catch (err) {
      console.error("Error signing visit:", err);
    } finally {
      setSigningVisit(false);
      setConfirmSign(false);
    }
  };

  const handleGeneratePdf = async () => {
    setGenerating(true);
    try {
      const res = await instance.post(`/visit/${id}/validate`, {
        outcome: visit.Evaluation.outcome,
        notes: visit.Evaluation.notes || null,
      });
      setVisit(res.data);
      if (res.data.evaluacionFilename) {
        toast.success("Constancia de aptitud generada");
        await handleDownloadPdf(res.data.evaluacionFilename, "eval");
      }
    } catch (err) {
      console.error("Error generating constancia:", err);
    } finally {
      setGenerating(false);
    }
  };

  const loadVisit = () => {
    setLoading(true);
    instance
      .get(`/visit/${id}`)
      .then((res) => setVisit(res.data))
      .finally(() => setLoading(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadVisit(); }, [id]);

  useEffect(() => {
    instance.get("/company?limit=500&offset=0&query=&laboral=1").then((res) => {
      setCompanies(res.data?.data || []);
    });
  }, []);

  // Sync champs depuis visit
  useEffect(() => {
    if (!visit) return;
    setVisitDate(dayjs(visit.visitDate));
    setEvalEnabled(!!visit.Evaluation);
    setEvalType(visit.Evaluation?.evaluationType || "");
    setEvalOutcome(visit.Evaluation?.outcome || "");
    setEvalNotes(visit.Evaluation?.notes || "");
    setCompanyId(visit.company_id ?? "");
    setCargo(visit.cargo ?? "");
    setDependencia(visit.dependencia ?? "");
    setTipoTrabajador(visit.employeeType ?? "");
    setMotivoConsulta(visit.motivoConsulta ?? "");
    setEnfermedadActual(visit.enfermedadActual ?? "");
    setTaSistolica(visit.taSistolica ?? "");
    setTaDiastolica(visit.taDiastolica ?? "");
    setPulso(visit.pulso ?? "");
    setPeso(visit.peso ?? "");
    setTalla(visit.talla ?? "");
    setTemperatura(visit.temperatura ?? "");
    setUsaLentes(visit.usaLentes ?? null);
    setPiel(visit.piel ?? "");
    setCabezaCuello(visit.cabezaCuello ?? "");
    setOjos(visit.ojos ?? "");
    setOrl(visit.orl ?? "");
    setExtremidadesSuperiores(visit.extremidadesSuperiores ?? "");
    setLinfaticos(visit.linfaticos ?? "");
    setToraxMamas(visit.toraxMamas ?? "");
    setPulmonar(visit.pulmonar ?? "");
    setCardiovascular(visit.cardiovascular ?? "");
    setAbdomen(visit.abdomen ?? "");
    setColumnaVertebral(visit.columnaVertebral ?? "");
    setZonaInguinoGenital(visit.zonaInguinoGenital ?? "");
    setExtremidadesInferiores(visit.extremidadesInferiores ?? "");
    setNeurologico(visit.neurologico ?? "");
    setSensibilidadReflejos(visit.sensibilidadReflejos ?? "");
    setDiagnostico((() => {
      if (!visit.diagnostico) return [];
      try { const p = JSON.parse(visit.diagnostico); return Array.isArray(p) ? p : []; }
      catch { return []; }
    })());
    setOtroDiagnostico(visit.otroDiagnostico ?? "");
    setPrescripcionExamenes(visit.prescripcionExamenes ?? "");
    const sl = visit.suspensionLaboral;
    setSuspEnabled(!!sl);
    setSuspDesde(sl?.desde ? dayjs(sl.desde) : null);
    setSuspHasta(sl?.hasta ? dayjs(sl.hasta) : null);
    setSuspDebeVolver(sl?.debeVolver ?? true);
    setSuspTipoReposo(sl?.tipoReposo || "EC");
    setSuspModalidad(sl?.modalidad || "ambulatorio");
    setSuspTipo(sl?.tipo || "primero");
    setSuspComienzo(sl?.comienzo ? dayjs(sl.comienzo) : null);
    setSuspMatInicioPrenatal(sl?.mat?.inicioPrenatal ? dayjs(sl.mat.inicioPrenatal) : null);
    setSuspMatFinPrenatal(sl?.mat?.finPrenatal ? dayjs(sl.mat.finPrenatal) : null);
    setSuspMatInicioPostnatal(sl?.mat?.inicioPostnatal ? dayjs(sl.mat.inicioPostnatal) : null);
    setSuspMatFinPostnatal(sl?.mat?.finPostnatal ? dayjs(sl.mat.finPostnatal) : null);
    setSuspObservacion(sl?.observacion || "");
  }, [visit]);

  // ── Handlers ────────────────────────────────────────────────

  const startEditLeft = () => setEditingLeft(true);

  const handleSaveLeft = async () => {
    setSavingLeft(true);
    try {
      await instance.post(`/visit/${id}`, {
        visitDate: visitDate.toISOString(),
        company_id: companyId || null,
        cargo: cargo || null,
        dependencia: dependencia || null,
        employeeType: tipoTrabajador || null,
        motivoConsulta: motivoConsulta || null,
        enfermedadActual: enfermedadActual || null,
      });
      let res;
      if (visit.type === "evaluacion" && evalEnabled) {
        res = await instance.post(`/visit/${id}/evaluation`, {
          evaluationType: evalType || null,
          outcome: evalOutcome || null,
          notes: evalNotes || null,
        });
      } else if (visit.type === "evaluacion" && !evalEnabled && visit.Evaluation) {
        res = await instance.delete(`/visit/${id}/evaluation`);
      } else {
        res = await instance.get(`/visit/${id}`);
      }
      setVisit(res.data);
      setEditingLeft(false);
    } catch (err) {
      console.error("Error saving:", err);
    } finally {
      setSavingLeft(false);
    }
  };

  const handleSaveVitales = async () => {
    setSavingVitales(true);
    try {
      const res = await instance.post(`/visit/${id}`, {
        taSistolica: taSistolica !== "" ? taSistolica : null,
        taDiastolica: taDiastolica !== "" ? taDiastolica : null,
        pulso: pulso !== "" ? pulso : null,
        peso: peso !== "" ? peso : null,
        talla: talla !== "" ? talla : null,
        temperatura: temperatura !== "" ? temperatura : null,
        usaLentes: usaLentes,
        piel: piel !== "" ? piel : null,
        cabezaCuello: cabezaCuello !== "" ? cabezaCuello : null,
        ojos: ojos !== "" ? ojos : null,
        orl: orl !== "" ? orl : null,
        extremidadesSuperiores: extremidadesSuperiores !== "" ? extremidadesSuperiores : null,
        linfaticos: linfaticos !== "" ? linfaticos : null,
        toraxMamas: toraxMamas !== "" ? toraxMamas : null,
        pulmonar: pulmonar !== "" ? pulmonar : null,
        cardiovascular: cardiovascular !== "" ? cardiovascular : null,
        abdomen: abdomen !== "" ? abdomen : null,
        columnaVertebral: columnaVertebral !== "" ? columnaVertebral : null,
        zonaInguinoGenital: zonaInguinoGenital !== "" ? zonaInguinoGenital : null,
        extremidadesInferiores: extremidadesInferiores !== "" ? extremidadesInferiores : null,
        neurologico: neurologico !== "" ? neurologico : null,
        sensibilidadReflejos: sensibilidadReflejos !== "" ? sensibilidadReflejos : null,
      });
      setVisit(res.data);
      setEditingVitales(false);
    } catch (err) {
      console.error("Error saving vitales:", err);
    } finally {
      setSavingVitales(false);
    }
  };

  const handleLoadPrevDiag = async () => {
    setLoadingPrevDiag(true);
    try {
      const res = await instance.get(`/visit/${id}/previous-diagnostico`);
      const items = JSON.parse(res.data.diagnostico);
      if (Array.isArray(items) && items.length > 0) {
        setDiagnostico(items);
        toast.info(`Diagnósticos importados de la visita del ${fmtDt(res.data.visitDate)}`);
      }
    } catch {
      toast.error("No se encontraron diagnósticos en visitas anteriores");
    } finally {
      setLoadingPrevDiag(false);
    }
  };

  const handleSaveDiag = async () => {
    setSavingDiag(true);
    try {
      const res = await instance.post(`/visit/${id}`, {
        diagnostico: diagnostico.length > 0 ? JSON.stringify(diagnostico) : null,
        otroDiagnostico: otroDiagnostico || null,
      });
      setVisit(res.data);
      setEditingDiag(false);
    } catch (err) {
      console.error("Error saving diagnostico:", err);
    } finally {
      setSavingDiag(false);
    }
  };

  const handleUploadAttachment = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingAttachment(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await instance.post(`/visit/${id}/attachments`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setVisit((prev) => ({ ...prev, attachments: res.data }));
    } catch (err) {
      console.error("Error uploading attachment:", err);
    } finally {
      setUploadingAttachment(false);
      e.target.value = "";
    }
  };

  const handleDeleteAttachment = async (attachmentId) => {
    setDeletingAttachment(attachmentId);
    try {
      const res = await instance.delete(`/visit/${id}/attachments/${attachmentId}`);
      setVisit((prev) => ({ ...prev, attachments: res.data }));
    } catch (err) {
      console.error("Error deleting attachment:", err);
    } finally {
      setDeletingAttachment(null);
    }
  };

  const handleDownloadAttachment = async (attachmentId, originalName) => {
    try {
      const res = await instance.get(`/visit/${id}/attachments/${attachmentId}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = originalName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading attachment:", err);
    }
  };

  const handleSavePrescripcion = async () => {
    setSavingPrescripcion(true);
    try {
      const res = await instance.post(`/visit/${id}`, {
        prescripcionExamenes: prescripcionExamenes || null,
      });
      setVisit(res.data);
      setEditingPrescripcion(false);
    } catch (err) {
      console.error("Error saving prescripcionExamenes:", err);
    } finally {
      setSavingPrescripcion(false);
    }
  };

  const handleSaveAnt = async () => {
    setSavingAnt(true);
    try {
      const res = await instance.post(`/visit/${id}/evaluation`, {
        antecedentesOcupacionales: antRef.current?.getPayload() || [],
      });
      setVisit(res.data);
      setEditingAnt(false);
    } catch (err) {
      console.error("Error saving antecedentes:", err);
    } finally {
      setSavingAnt(false);
    }
  };

  const handleGenerateSuspPdf = async () => {
    setGeneratingSusp(true);
    try {
      const res = await instance.post(`/visit/${id}/validate-suspension`);
      setVisit(res.data);
      if (res.data.reposoMedicoFilename) {
        toast.success("Constancia de reposo médico generada");
        await handleDownloadPdf(res.data.reposoMedicoFilename, "reposo");
      }
    } catch (err) {
      console.error("Error generating suspension constancia:", err);
    } finally {
      setGeneratingSusp(false);
    }
  };

  const handleSaveSusp = async () => {
    setSavingSusp(true);
    try {
      const payload = suspEnabled ? {
        suspensionLaboral: {
          desde: suspDesde?.toISOString() || null,
          hasta: suspHasta?.toISOString() || null,
          debeVolver: suspDebeVolver,
          tipoReposo: suspTipoReposo,
          modalidad: suspModalidad,
          tipo: suspTipo,
          comienzo: suspComienzo?.toISOString() || null,
          mat: {
            inicioPrenatal: suspMatInicioPrenatal?.toISOString() || null,
            finPrenatal: suspMatFinPrenatal?.toISOString() || null,
            inicioPostnatal: suspMatInicioPostnatal?.toISOString() || null,
            finPostnatal: suspMatFinPostnatal?.toISOString() || null,
          },
          observacion: suspObservacion || null,
        },
      } : { suspensionLaboral: null };
      const saved = await instance.post(`/visit/${id}`, payload);
      setVisit(saved.data);
      setEditingSusp(false);
    } catch (err) {
      console.error("Error saving suspension:", err);
    } finally {
      setSavingSusp(false);
    }
  };


  const handleDelete = async () => {
    try {
      const pid = visit?.Patient?.id || visit?.patient_id;
      await instance.delete(`/visit/${id}`);
      navigate(`/patients/${pid}`, { replace: true });
    } catch (err) {
      console.error("Error deleting visit:", err);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!visit) {
    return <Typography>Visita no encontrada.</Typography>;
  }

  const patientId = visit.Patient?.id || visit.patient_id;
  const isSigned = visit.status === "signed";
  const canEdit = !isSigned || currentUser?.type === "admin";

  return (
    <>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>

      <Button
        startIcon={<ArrowBackIcon />}
        size="small"
        onClick={() => navigate(`/patients/${patientId}`)}
        sx={{ alignSelf: "flex-start", mb: 1, color: "text.secondary" }}
      >
        Volver
      </Button>

      {/* ── Stepper flux de visite ───────────────────────────── */}
      {(() => {
        const hasDiagnostico = (!!visit.diagnostico && visit.diagnostico !== "[]") || !!visit.otroDiagnostico;
        const canGenerate = !!visit.company_id && hasDiagnostico && !!visit.motivoConsulta;
        const activeStep = visit.status === "signed" ? 4 : visit.status === "waiting_sign" ? 2 : (visit.status === "completed" || canGenerate) ? 1 : 0;
        const steps = ["Consulta", "Histórico", "Firma", "Terminada"];
        return (
          <Box sx={{ mb: 3 }}>
            <Box sx={{ flex: 1 }}>
            <Stepper activeStep={activeStep} sx={{ mb: activeStep < 4 ? 1.5 : 0 }}>
              {steps.map((label) => (
                <Step key={label}><StepLabel>{label}</StepLabel></Step>
              ))}
            </Stepper>
            {activeStep === 0 && (
              <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
                Por favor indique al mínimo la empresa, el motivo de consulta y el diagnóstico para poder generar el histórico del paciente.
              </Typography>
            )}
            {activeStep === 1 && (
              <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
                Puedes{" "}
                <Typography
                  component="span"
                  variant="body2"
                  color="primary"
                  sx={{ cursor: generatingReport ? "wait" : "pointer", textDecoration: "underline" }}
                  onClick={!generatingReport ? handleGenerateReport : undefined}
                >
                  {generatingReport ? "Generando…" : "generar el histórico"}
                </Typography>
                {" "}para que el paciente lo firme o seguir modificando la consulta.
              </Typography>
            )}
            {activeStep === 2 && (
              <Box display="flex" flexDirection="column" alignItems="center" gap={2} sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" align="center">
                  Puedes{" "}
                  <Typography
                    component="span" variant="body2" color="primary"
                    sx={{ cursor: downloadingPdf === "historico" ? "wait" : "pointer", textDecoration: "underline" }}
                    onClick={() => visit.historicoFilename && handleDownloadPdf(visit.historicoFilename, "historico")}
                  >
                    descargar el histórico
                  </Typography>
                  {" "}o{" "}
                  <Typography
                    component="span" variant="body2" color="primary"
                    sx={{ cursor: generatingReport ? "wait" : "pointer", textDecoration: "underline" }}
                    onClick={!generatingReport ? handleGenerateReport : undefined}
                  >
                    {generatingReport ? "Generando…" : "generarlo de nuevo"}
                  </Typography>
                  .
                </Typography>
                <Button variant="contained" color="success" onClick={() => setConfirmSign(true)}>
                  El paciente firmó
                </Button>
              </Box>
            )}
            {activeStep === 4 && (
              <Typography variant="body2" color="text.secondary" align="center" fontWeight="bold" sx={{ mt: 2 }}>
                Visita completada y firmada por el paciente.
              </Typography>
            )}
            </Box>
          </Box>
        );
      })()}

      <Grid container spacing={2} sx={{ flex: 1, alignItems: "stretch" }}>

        {/* ── Card gauche ─────────────────────────────────────── */}
        <Grid item xs={12} md={5} sx={{ display: "flex" }}>
          <Paper sx={{ p: 3, flex: 1, display: "flex", flexDirection: "column" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography variant="h6">Visita #{visit.id}</Typography>
              <IconButton size="small" color="error" onClick={() => setConfirmDelete(true)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
            <Divider sx={{ mb: 2 }} />

            {/* Fecha */}
            {editingLeft ? (
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <DateTimePicker
                  label="Fecha"
                  value={visitDate}
                  onChange={setVisitDate}
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                />
              </LocalizationProvider>
            ) : (
              <InfoRow label="Fecha" value={fmtDt(visit.visitDate)} />
            )}

            <InfoRow label="Tipo" value={visit.type === "evaluacion" ? "Consulta médica ocupacional" : "Consulta general"} />
            <InfoRow label="Médico" value={visit.User?.displayName} />
            <InfoRow label="Especialidad" value={visit.User?.specialty} />

            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Datos laborales</Typography>
            {editingLeft ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <FormControl fullWidth size="small">
                  <InputLabel>Empresa</InputLabel>
                  <Select value={companyId} label="Empresa" onChange={(e) => setCompanyId(e.target.value)}>
                    <MenuItem value=""><em>Sin empresa</em></MenuItem>
                    {companies.map((c) => (
                      <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField label="Cargo" size="small" fullWidth value={cargo} onChange={(e) => setCargo(e.target.value)} />
                <TextField label="Dependencia" size="small" fullWidth value={dependencia} onChange={(e) => setDependencia(e.target.value)} />
                <FormControl fullWidth size="small">
                  <InputLabel>Tipo de trabajador</InputLabel>
                  <Select value={tipoTrabajador} label="Tipo de trabajador" onChange={(e) => setTipoTrabajador(e.target.value)}>
                    <MenuItem value=""><em>Sin especificar</em></MenuItem>
                    <MenuItem value="Obrero">Obrero</MenuItem>
                    <MenuItem value="Empleado">Empleado</MenuItem>
                    <MenuItem value="Supervisor">Supervisor</MenuItem>
                    <MenuItem value="Gerente">Gerente</MenuItem>
                    <MenuItem value="Directivo">Directivo</MenuItem>
                    <MenuItem value="Contratado">Contratado</MenuItem>
                    <MenuItem value="Pasante">Pasante</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            ) : (
              <>
                <InfoRow label="Empresa" value={visit.Company?.name} />
                <InfoRow label="Cargo" value={visit.cargo} />
                <InfoRow label="Dependencia" value={visit.dependencia} />
                <InfoRow label="Tipo de trabajador" value={visit.employeeType} />
              </>
            )}

            {(editingLeft || visit.motivoConsulta || visit.enfermedadActual) && (
              <>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Consulta</Typography>
                {editingLeft ? (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                      label="Motivo de la consulta" size="small" fullWidth multiline rows={2}
                      value={motivoConsulta} onChange={(e) => setMotivoConsulta(e.target.value)}
                    />
                    <TextField
                      label="Enfermedad actual" size="small" fullWidth multiline rows={3}
                      value={enfermedadActual} onChange={(e) => setEnfermedadActual(e.target.value)}
                    />
                  </Box>
                ) : (
                  <>
                    <InfoRow label="Motivo de la consulta" value={visit.motivoConsulta} />
                    <InfoRow label="Enfermedad actual" value={visit.enfermedadActual} />
                  </>
                )}
              </>
            )}

            {/* Sección evaluación */}
            {visit.type === "evaluacion" && (
              <>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                  <Typography variant="subtitle2">Evaluación</Typography>
                  {editingLeft ? (
                    <FormControlLabel
                      control={<Switch size="small" checked={evalEnabled} onChange={(e) => {
                        setEvalEnabled(e.target.checked);
                        if (e.target.checked && !evalType) setEvalType("Pre-empleo");
                        if (e.target.checked && !evalOutcome) setEvalOutcome("apto");
                      }} />}
                      label={<Typography variant="caption">{evalEnabled ? "Activa" : "Inactiva"}</Typography>}
                      labelPlacement="start"
                      sx={{ mr: 0, ml: 0 }}
                    />
                  ) : (() => {
                    const noCompany = currentUser?.type === "medecin" && !visit.company_id;
                    const canGenerate = !noCompany && !!(visit.Evaluation?.evaluationType && visit.Evaluation?.outcome);
                    const tooltipMsg = noCompany
                      ? "Se requiere una empresa en los datos laborales"
                      : !visit.Evaluation?.evaluationType
                      ? "Selecciona un tipo de evaluación"
                      : !visit.Evaluation?.outcome
                      ? "Selecciona un resultado"
                      : "Generar evaluación PDF";
                    return (
                      <Tooltip title={tooltipMsg}>
                        <span>
                          <IconButton size="small" color="primary" onClick={handleGeneratePdf} disabled={generating || !canGenerate}>
                            {generating ? <CircularProgress size={16} /> : <AutoAwesomeIcon fontSize="small" />}
                          </IconButton>
                        </span>
                      </Tooltip>
                    );
                  })()}
                </Box>

                {editingLeft ? (
                  evalEnabled ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Tipo de evaluación</InputLabel>
                        <Select value={evalType} label="Tipo de evaluación" onChange={(e) => setEvalType(e.target.value)}>
                          <MenuItem value="Pre-empleo">Pre-empleo</MenuItem>
                          <MenuItem value="Periódico">Periódico</MenuItem>
                          <MenuItem value="Post-empleo">Post-empleo</MenuItem>
                          <MenuItem value="Reintegro">Reintegro</MenuItem>
                          <MenuItem value="Por cambio de ocupación">Por cambio de ocupación</MenuItem>
                          <MenuItem value="Post-incapacidad">Post-incapacidad</MenuItem>
                          <MenuItem value="Pre-vacacional">Pre-vacacional</MenuItem>
                          <MenuItem value="Post-vacacional">Post-vacacional</MenuItem>
                          <MenuItem value="Egreso">Egreso</MenuItem>
                          <MenuItem value="Accidente laboral">Accidente laboral</MenuItem>
                          <MenuItem value="Accidente común">Accidente común</MenuItem>
                          <MenuItem value="Consulta general">Consulta general</MenuItem>
                          <MenuItem value="Pre-natal">Pre-natal</MenuItem>
                          <MenuItem value="Post-natal">Post-natal</MenuItem>
                          <MenuItem value="Post-reposo">Post-reposo</MenuItem>
                          <MenuItem value="Conformación de reposo">Conformación de reposo</MenuItem>
                          <MenuItem value="Emergencia">Emergencia</MenuItem>
                          <MenuItem value="Rutina">Rutina</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth size="small">
                        <InputLabel>Resultado</InputLabel>
                        <Select value={evalOutcome} label="Resultado" onChange={(e) => setEvalOutcome(e.target.value)}>
                          {Object.entries(outcomeLabels).map(([val, { label }]) => (
                            <MenuItem key={val} value={val}>{label}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <TextField
                        label="Observaciones" size="small" fullWidth multiline rows={3}
                        value={evalNotes} onChange={(e) => setEvalNotes(e.target.value)}
                      />
                    </Box>
                  ) : (
                    <Typography variant="body2" color="text.secondary">Sin evaluación.</Typography>
                  )
                ) : (
                  <>
                    <InfoRow label="Tipo de evaluación" value={visit.Evaluation?.evaluationType} />
                    {visit.Evaluation?.outcome && (
                      <Box sx={{ mb: 1.5 }}>
                        <Typography variant="caption" color="text.secondary">Resultado</Typography>
                        <Box mt={0.5}>
                          <Chip
                            label={outcomeLabels[visit.Evaluation.outcome]?.label || visit.Evaluation.outcome}
                            color={outcomeLabels[visit.Evaluation.outcome]?.color || "default"}
                            size="small"
                          />
                        </Box>
                      </Box>
                    )}
                    <InfoRow label="Observaciones" value={visit.Evaluation?.notes} />
                    {visit.Evaluation?.validatedAt && (
                      <InfoRow label="Validada el" value={fmtDt(visit.Evaluation.validatedAt)} />
                    )}
                    {!visit.Evaluation && (
                      <Typography variant="body2" color="text.secondary">Sin evaluación registrada.</Typography>
                    )}
                  </>
                )}
              </>
            )}

            {/* Documents */}
            <Divider sx={{ my: 2 }} />
            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
              <Typography variant="subtitle2">Documentos</Typography>
              <>
                <input ref={attachmentInputRef} type="file" style={{ display: "none" }} onChange={handleUploadAttachment} />
                <Tooltip title="Adjuntar documento">
                  <span>
                    <IconButton size="small" disabled={uploadingAttachment} onClick={() => attachmentInputRef.current.click()}>
                      {uploadingAttachment ? <CircularProgress size={14} /> : <AddIcon fontSize="small" />}
                    </IconButton>
                  </span>
                </Tooltip>
              </>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {[
                { key: "eval",      filename: visit.evaluacionFilename,    label: "Constancia de Aptitud" },
                { key: "reposo",    filename: visit.reposoMedicoFilename,  label: "Constancia de Reposo Médico" },
                { key: "historico", filename: visit.historicoFilename,     label: "Informe de Visita" },
              ].filter(d => d.filename).map(({ key, filename, label }) => (
                <Box
                  key={key}
                  onClick={() => downloadingPdf !== key && handleDownloadPdf(filename, key)}
                  sx={{
                    display: "flex", alignItems: "center", gap: 1,
                    px: 1, py: 0.5, borderRadius: 1,
                    cursor: downloadingPdf === key ? "wait" : "pointer",
                    opacity: downloadingPdf === key ? 0.5 : 1,
                    "&:hover": { bgcolor: "action.hover" },
                  }}
                >
                  {downloadingPdf === key
                    ? <CircularProgress size={14} />
                    : <PictureAsPdfIcon fontSize="small" color="error" sx={{ flexShrink: 0 }} />
                  }
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body2" sx={{ lineHeight: 1.2 }}>{label}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {fmtDt(visit.visitDate)}
                    </Typography>
                  </Box>
                </Box>
              ))}

              {/* Pièces jointes */}
              {(visit.attachments || []).map((att) => (
                <Box
                  key={att.id}
                  sx={{ display: "flex", alignItems: "center", gap: 1, px: 1, py: 0.5, borderRadius: 1, "&:hover": { bgcolor: "action.hover" } }}
                >
                  <AttachFileIcon fontSize="small" color="action" sx={{ flexShrink: 0 }} />
                  <Box
                    sx={{ flex: 1, cursor: "pointer" }}
                    onClick={() => handleDownloadAttachment(att.id, att.originalName)}
                  >
                    <Typography variant="body2" sx={{ lineHeight: 1.2 }}>{att.originalName}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {dayjs(att.uploadedAt).format("DD/MM/YYYY HH:mm")} · {(att.size / 1024).toFixed(0)} Ko
                    </Typography>
                  </Box>
                  {canEdit && (
                    <IconButton size="small" onClick={() => handleDeleteAttachment(att.id)} disabled={deletingAttachment === att.id}>
                      {deletingAttachment === att.id ? <CircularProgress size={14} /> : <DeleteIcon fontSize="small" />}
                    </IconButton>
                  )}
                </Box>
              ))}

            </Box>

            {/* Footer card gauche */}
            <Box display="flex" gap={1} justifyContent="flex-end" mt="auto" pt={2}>
              {editingLeft ? (
                <>
                  <Button size="small" startIcon={<CancelIcon />} onClick={() => setEditingLeft(false)}>Cancelar</Button>
                  <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveLeft} disabled={savingLeft}>
                    Guardar
                  </Button>
                </>
              ) : (
                <>
                  {(visit.status !== "signed" || currentUser?.type === "admin") && (
                    <Button size="small" startIcon={<EditIcon />} onClick={startEditLeft}>Editar</Button>
                  )}
                </>
              )}
            </Box>
          </Paper>
        </Grid>

        {/* ── Colonne droite ───────────────────────────────────── */}
        <Grid item xs={12} md={7} sx={{ display: "flex", flexDirection: "column" }}>

          {/* Card signos vitales */}
          <Paper sx={{ p: 3, mb: 2, display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Signos vitales</Typography>
            <Divider sx={{ mb: 2 }} />

            {editingVitales ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box display="flex" gap={1} alignItems="center">
                  <TextField
                    label="TA Sistólica" size="small" type="number"
                    value={taSistolica} onChange={(e) => setTaSistolica(e.target.value)}
                    InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 0.5 }}>mmHg</Typography> }}
                    sx={{ flex: 1 }}
                  />
                  <Typography>/</Typography>
                  <TextField
                    label="TA Diastólica" size="small" type="number"
                    value={taDiastolica} onChange={(e) => setTaDiastolica(e.target.value)}
                    InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 0.5 }}>mmHg</Typography> }}
                    sx={{ flex: 1 }}
                  />
                </Box>
                <TextField
                  label="Pulso / FC" size="small" type="number"
                  value={pulso} onChange={(e) => setPulso(e.target.value)}
                  InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 0.5 }}>lpm</Typography> }}
                />
                <TextField
                  label="Peso" size="small" type="number"
                  value={peso} onChange={(e) => setPeso(e.target.value)}
                  InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 0.5 }}>kg</Typography> }}
                />
                <TextField
                  label="Talla" size="small" type="number"
                  value={talla} onChange={(e) => setTalla(e.target.value)}
                  InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 0.5 }}>cm</Typography> }}
                />
                <TextField
                  label="Temperatura" size="small" type="number"
                  value={temperatura} onChange={(e) => setTemperatura(e.target.value)}
                  InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 0.5 }}>°C</Typography> }}
                />
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                  <Typography variant="subtitle2" color="text.secondary">Examen físico</Typography>
                  <Button size="small" variant="outlined" sx={{ fontSize: 11 }} onClick={() => {
                    const val = "Normal";
                    setPiel(val); setCabezaCuello(val); setOjos(val); setOrl(val);
                    setExtremidadesSuperiores(val); setLinfaticos(val); setToraxMamas(val);
                    setPulmonar(val); setCardiovascular(val); setAbdomen(val);
                    setColumnaVertebral(val); setZonaInguinoGenital(val);
                    setExtremidadesInferiores(val); setNeurologico(val); setSensibilidadReflejos(val);
                  }}>Rellenar normal</Button>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Usa lentes</Typography>
                  <ToggleButtonGroup size="small" exclusive
                    value={usaLentes === true ? "si" : usaLentes === false ? "no" : ""}
                    onChange={(e, v) => setUsaLentes(v === "si" ? true : v === "no" ? false : null)}
                  >
                    <ToggleButton value="si">Sí</ToggleButton>
                    <ToggleButton value="no">No</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
                  <TextField label="Piel" size="small" value={piel} onChange={(e) => setPiel(e.target.value)} />
                  <TextField label="Cabeza y cuello" size="small" value={cabezaCuello} onChange={(e) => setCabezaCuello(e.target.value)} />
                  <TextField label="Ojos" size="small" value={ojos} onChange={(e) => setOjos(e.target.value)} />
                  <TextField label="ORL" size="small" value={orl} onChange={(e) => setOrl(e.target.value)} />
                  <TextField label="Extremidades superiores" size="small" value={extremidadesSuperiores} onChange={(e) => setExtremidadesSuperiores(e.target.value)} />
                  <TextField label="Linfáticos" size="small" value={linfaticos} onChange={(e) => setLinfaticos(e.target.value)} />
                  <TextField label="Tórax y mamas" size="small" value={toraxMamas} onChange={(e) => setToraxMamas(e.target.value)} />
                  <TextField label="Pulmonar" size="small" value={pulmonar} onChange={(e) => setPulmonar(e.target.value)} />
                  <TextField label="Cardiovascular" size="small" value={cardiovascular} onChange={(e) => setCardiovascular(e.target.value)} />
                  <TextField label="Abdomen" size="small" value={abdomen} onChange={(e) => setAbdomen(e.target.value)} />
                  <TextField label="Columna vertebral" size="small" value={columnaVertebral} onChange={(e) => setColumnaVertebral(e.target.value)} />
                  <TextField label="Zona inguino-genital" size="small" value={zonaInguinoGenital} onChange={(e) => setZonaInguinoGenital(e.target.value)} />
                  <TextField label="Extremidades inferiores" size="small" value={extremidadesInferiores} onChange={(e) => setExtremidadesInferiores(e.target.value)} />
                  <TextField label="Neurológico" size="small" value={neurologico} onChange={(e) => setNeurologico(e.target.value)} />
                </Box>
                <TextField
                  label="Sensibilidad y reflejos" size="small" fullWidth multiline rows={2}
                  value={sensibilidadReflejos} onChange={(e) => setSensibilidadReflejos(e.target.value)}
                />
              </Box>
            ) : [visit.taSistolica, visit.pulso, visit.peso, visit.talla, visit.temperatura, visit.usaLentes, visit.piel, visit.cabezaCuello, visit.ojos, visit.orl, visit.extremidadesSuperiores, visit.linfaticos, visit.toraxMamas, visit.pulmonar, visit.cardiovascular, visit.abdomen, visit.columnaVertebral, visit.zonaInguinoGenital, visit.extremidadesInferiores, visit.neurologico, visit.sensibilidadReflejos].every(v => v == null || v === "") ? (
              <Box sx={{ py: 1.5, textAlign: "center" }}>
                <Typography variant="body2" color="text.disabled" sx={{ mb: 1.5 }}>
                  Sin signos vitales registrados
                </Typography>
                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: "center", mb: 1.5 }}>
                  {[
                    { label: "TA", unit: "mmHg" },
                    { label: "Pulso / FC", unit: "lpm" },
                    { label: "Peso", unit: "kg" },
                    { label: "Talla", unit: "cm" },
                    { label: "Temperatura", unit: "°C" },
                  ].map(({ label, unit }) => (
                    <Chip key={label} size="small" variant="outlined"
                      label={<><span style={{ fontWeight: 500 }}>{label}</span><span style={{ opacity: 0.6, marginLeft: 4 }}>{unit}</span></>}
                      sx={{ opacity: 0.5 }}
                    />
                  ))}
                </Box>
                <Typography variant="body2" color="text.disabled" sx={{ mb: 1.5 }}>
                  Sin examen físico registrado
                </Typography>
                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: "center" }}>
                  {["Usa lentes", "Piel", "Cabeza y cuello", "Ojos", "ORL", "Extremidades superiores", "Linfáticos", "Tórax y mamas", "Pulmonar", "Cardiovascular", "Abdomen", "Columna vertebral", "Zona inguino-genital", "Extremidades inferiores", "Neurológico", "Sensibilidad y reflejos"].map((label) => (
                    <Chip key={label} size="small" variant="outlined" label={label} sx={{ opacity: 0.5 }} />
                  ))}
                </Box>
              </Box>
            ) : (
              <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
                <InfoRow label="TA" value={visit.taSistolica != null ? `${visit.taSistolica}/${visit.taDiastolica} mmHg` : null} />
                <InfoRow label="Pulso / FC" value={visit.pulso != null ? `${visit.pulso} lpm` : null} />
                <InfoRow label="Peso" value={visit.peso != null ? `${visit.peso} kg` : null} />
                <InfoRow label="Talla" value={visit.talla != null ? `${visit.talla} cm` : null} />
                <InfoRow label="Temperatura" value={visit.temperatura != null ? `${visit.temperatura} °C` : null} />
                {(() => {
                  const hasExam = [visit.piel, visit.cabezaCuello, visit.ojos, visit.orl, visit.extremidadesSuperiores, visit.linfaticos, visit.toraxMamas, visit.pulmonar, visit.cardiovascular, visit.abdomen, visit.columnaVertebral, visit.zonaInguinoGenital, visit.extremidadesInferiores, visit.neurologico, visit.sensibilidadReflejos].some(v => v != null && v !== "") || visit.usaLentes != null;
                  if (!hasExam) return null;
                  return (
                    <>
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Divider sx={{ my: 1 }} />
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Examen físico</Typography>
                      </Box>
                      <InfoRow label="Usa lentes" value={visit.usaLentes != null ? (visit.usaLentes ? "Sí" : "No") : null} />
                      <InfoRow label="Piel" value={visit.piel} />
                      <InfoRow label="Cabeza y cuello" value={visit.cabezaCuello} />
                      <InfoRow label="Ojos" value={visit.ojos} />
                      <InfoRow label="ORL" value={visit.orl} />
                      <InfoRow label="Extremidades superiores" value={visit.extremidadesSuperiores} />
                      <InfoRow label="Linfáticos" value={visit.linfaticos} />
                      <InfoRow label="Tórax y mamas" value={visit.toraxMamas} />
                      <InfoRow label="Pulmonar" value={visit.pulmonar} />
                      <InfoRow label="Cardiovascular" value={visit.cardiovascular} />
                      <InfoRow label="Abdomen" value={visit.abdomen} />
                      <InfoRow label="Columna vertebral" value={visit.columnaVertebral} />
                      <InfoRow label="Zona inguino-genital" value={visit.zonaInguinoGenital} />
                      <InfoRow label="Extremidades inferiores" value={visit.extremidadesInferiores} />
                      <InfoRow label="Neurológico" value={visit.neurologico} />
                      {visit.sensibilidadReflejos && <Box sx={{ gridColumn: "1 / -1" }}><InfoRow label="Sensibilidad y reflejos" value={visit.sensibilidadReflejos} /></Box>}
                    </>
                  );
                })()}
              </Box>
            )}

            {/* Footer card vitales */}
            <Box display="flex" gap={1} justifyContent="flex-end" mt={2}>
              {editingVitales ? (
                <>
                  <Button size="small" startIcon={<CancelIcon />} onClick={() => setEditingVitales(false)}>Cancelar</Button>
                  <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveVitales} disabled={savingVitales}>
                    Guardar
                  </Button>
                </>
              ) : (
                <Button size="small" startIcon={<EditIcon />} onClick={() => setEditingVitales(true)} disabled={!canEdit}>Editar</Button>
              )}
            </Box>
          </Paper>

          {/* Card diagnóstico */}
          <Paper sx={{ p: 3, mb: 2, display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Diagnóstico</Typography>
            <Divider sx={{ mb: 2 }} />
            {editingDiag ? (
              <>
              <Autocomplete
                multiple
                options={CIE10}
                getOptionLabel={(opt) => `${opt.code} — ${opt.label}`}
                value={diagnostico}
                onChange={(_, newValue) => setDiagnostico(newValue)}
                isOptionEqualToValue={(opt, val) => opt.code === val.code}
                filterOptions={(options, { inputValue }) => {
                  const q = inputValue.toLowerCase();
                  return options.filter(o =>
                    o.code.toLowerCase().includes(q) || o.label.toLowerCase().includes(q)
                  ).slice(0, 50);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" placeholder="Buscar por código o descripción CIE-10..." />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((opt, index) => (
                    <Chip
                      key={opt.code}
                      label={`${opt.code} — ${opt.label}`}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))
                }
              />
              <Typography variant="caption" color="text.disabled" sx={{ mt: 0.5, display: "block" }}>
                {"Fuente: "}<a href="https://cie.minsa.gob.pe/pages/cie.aspx" target="_blank" rel="noopener noreferrer">{"Clasificación Internacional de Enfermedades CIE-10 (OMS / MPPS)"}</a>
              </Typography>
              <TextField
                label="Otro diagnóstico" size="small" fullWidth multiline rows={2}
                value={otroDiagnostico}
                onChange={(e) => setOtroDiagnostico(e.target.value)}
                sx={{ mt: 1.5 }}
                helperText="Utilice este campo solo si el diagnóstico no se encuentra en la lista CIE-10. Se recomienda priorizar la codificación estándar."
              />
              </>
            ) : diagnostico.length > 0 || visit.otroDiagnostico ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {diagnostico.length > 0 && (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {diagnostico.map((d) => (
                      <Chip key={d.code} label={`${d.code} — ${d.label}`} size="small" variant="outlined" />
                    ))}
                  </Box>
                )}
                {visit.otroDiagnostico && (
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                    Otro: {visit.otroDiagnostico}
                  </Typography>
                )}
              </Box>
            ) : (
              <Box sx={{ py: 1.5, textAlign: "center" }}>
                <Typography variant="body2" color="text.disabled">Sin diagnóstico registrado</Typography>
              </Box>
            )}
            <Box display="flex" gap={1} justifyContent="flex-end" mt={2}>
              {editingDiag ? (
                <>
                  <Button size="small" variant="outlined" onClick={handleLoadPrevDiag} disabled={loadingPrevDiag}>
                    {loadingPrevDiag ? "Cargando..." : "Importar de visita anterior"}
                  </Button>
                  <Button size="small" startIcon={<CancelIcon />} onClick={() => { setDiagnostico((() => { if (!visit.diagnostico) return []; try { const p = JSON.parse(visit.diagnostico); return Array.isArray(p) ? p : []; } catch { return []; } })()); setOtroDiagnostico(visit.otroDiagnostico ?? ""); setEditingDiag(false); }}>Cancelar</Button>
                  <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveDiag} disabled={savingDiag}>Guardar</Button>
                </>
              ) : (
                <Button size="small" startIcon={<EditIcon />} onClick={() => setEditingDiag(true)} disabled={!canEdit}>Editar</Button>
              )}
            </Box>
          </Paper>

          {/* Card prescripción de exámenes */}
          <Paper sx={{ p: 3, mb: 2, display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Prescripción de Tratamiento/Exámenes</Typography>
            <Divider sx={{ mb: 2 }} />
            {editingPrescripcion ? (
              <TextField
                size="small" fullWidth multiline minRows={4}
                placeholder="Prescripción de exámenes..."
                value={prescripcionExamenes}
                onChange={(e) => setPrescripcionExamenes(e.target.value)}
              />
            ) : visit.prescripcionExamenes ? (
              <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{visit.prescripcionExamenes}</Typography>
            ) : (
              <Box sx={{ py: 1.5, textAlign: "center" }}>
                <Typography variant="body2" color="text.disabled">Sin prescripción registrada</Typography>
              </Box>
            )}
            <Box display="flex" gap={1} justifyContent="flex-end" mt={2}>
              {editingPrescripcion ? (
                <>
                  <Button size="small" startIcon={<CancelIcon />} onClick={() => { setPrescripcionExamenes(visit.prescripcionExamenes ?? ""); setEditingPrescripcion(false); }}>Cancelar</Button>
                  <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSavePrescripcion} disabled={savingPrescripcion}>Guardar</Button>
                </>
              ) : (
                <Button size="small" startIcon={<EditIcon />} onClick={() => setEditingPrescripcion(true)} disabled={!canEdit}>Editar</Button>
              )}
            </Box>
          </Paper>

          {/* Card antécédentes */}
          {visit.type === "evaluacion" && (() => {
            const ant = visit.Evaluation?.antecedentesOcupacionales;
            const parsedAnt = (() => {
              if (!ant) return { rows: [], otros: {} };
              let p = ant;
              if (typeof ant === "string") { try { p = JSON.parse(ant); } catch { return { rows: [], otros: {} }; } }
              if (Array.isArray(p)) return { rows: p, otros: {} };
              return { rows: p.rows || [], otros: p.otros || {} };
            })();
            const hasAntData =
              parsedAnt.rows.some((r) => r.tipo || r.descripcion || r.meses || r.anos) ||
              Object.values(parsedAnt.otros).some((v) => v !== null && v !== "");
            return (
            <Paper sx={{ p: 3, mb: 2, display: "flex", flexDirection: "column" }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Antecedentes ocupacionales</Typography>
              <Divider sx={{ mb: 2 }} />
              {!editingAnt && !hasAntData ? (
                <Box sx={{ py: 1.5, textAlign: "center" }}>
                  <Typography variant="body2" color="text.disabled" sx={{ mb: 1.5 }}>
                    Sin antecedentes ocupacionales registrados
                  </Typography>
                  <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: "center" }}>
                    {["Físicos", "Químicos", "Biológicos", "Disergonómico", "Mecánicos", "Otros"].map((cat) => (
                      <Chip key={cat} size="small" variant="outlined" label={cat} sx={{ opacity: 0.5 }} />
                    ))}
                  </Box>
                </Box>
              ) : (
                <AntecedentesOcupacionales
                  ref={antRef}
                  evaluation={visit.Evaluation}
                  editing={editingAnt}
                />
              )}
              {/* Footer */}
              <Box display="flex" gap={1} justifyContent="flex-end" mt="auto" pt={2}>
                {editingAnt ? (
                  <>
                    <Button size="small" startIcon={<CancelIcon />} onClick={() => setEditingAnt(false)}>Cancelar</Button>
                    <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveAnt} disabled={savingAnt}>
                      Guardar
                    </Button>
                  </>
                ) : (
                  <Button size="small" startIcon={<EditIcon />} onClick={() => setEditingAnt(true)} disabled={!canEdit}>
                    Editar
                  </Button>
                )}
              </Box>
            </Paper>
          );
          })()}

          {visit.type === "consulta" && (
            <Paper sx={{ p: 3, mb: 2 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Consulta general</Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                Los campos específicos de consulta se definirán próximamente.
              </Typography>
            </Paper>
          )}

          {/* ── Card Reposo médico ─────────────────────── */}
          {visit.type === "evaluacion" && <Paper sx={{ p: 3, display: "flex", flexDirection: "column" }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h6">Reposo médico</Typography>
              {editingSusp ? (
                <FormControlLabel
                  control={<Switch size="small" checked={suspEnabled} onChange={(e) => {
                    setSuspEnabled(e.target.checked);
                    if (e.target.checked && !suspDesde) setSuspDesde(dayjs());
                  }} />}
                  label={<Typography variant="caption">{suspEnabled ? "Activa" : "Inactiva"}</Typography>}
                  labelPlacement="start"
                  sx={{ mr: 0, ml: 0 }}
                />
              ) : (() => {
                const noCompany = currentUser?.type === "medecin" && !visit.company_id;
                const suspTooltip = noCompany
                  ? "Se requiere una empresa en los datos laborales"
                  : !visit.suspensionLaboral
                  ? "No hay reposo médico registrado"
                  : "Generar reposo médico PDF";
                return (
                  <Tooltip title={suspTooltip}>
                    <span>
                      <IconButton size="small" color="primary" onClick={handleGenerateSuspPdf} disabled={generatingSusp || !visit.suspensionLaboral || noCompany}>
                        {generatingSusp ? <CircularProgress size={16} /> : <AutoAwesomeIcon fontSize="small" />}
                      </IconButton>
                    </span>
                  </Tooltip>
                );
              })()}
            </Box>
            <Divider sx={{ mb: 2 }} />

            {editingSusp ? (
              suspEnabled ? (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                    {/* Desde + Debe volver */}
                    <Box display="flex" gap={2} alignItems="flex-end">
                      <DatePicker label="Desde" value={suspDesde} onChange={setSuspDesde}
                        slotProps={{ textField: { size: "small", fullWidth: true } }} />
                      <Box>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Debe volver</Typography>
                        <ToggleButtonGroup size="small" exclusive value={suspDebeVolver === true ? "si" : suspDebeVolver === false ? "no" : ""}
                          onChange={(e, v) => setSuspDebeVolver(v === "si" ? true : v === "no" ? false : null)}>
                          <ToggleButton value="si">Sí</ToggleButton>
                          <ToggleButton value="no">No</ToggleButton>
                        </ToggleButtonGroup>
                      </Box>
                    </Box>

                    {/* Tipo de reposo */}
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Tipo de reposo</Typography>
                      <Box display="flex" gap={1} flexWrap="wrap">
                        <ToggleButtonGroup size="small" exclusive value={suspTipoReposo}
                          onChange={(e, v) => v && setSuspTipoReposo(v)}>
                          {["EC", "AC", "AT", "EP"].map((t) => <ToggleButton key={t} value={t}>{t}</ToggleButton>)}
                        </ToggleButtonGroup>
                        <ToggleButtonGroup size="small" exclusive value={suspModalidad}
                          onChange={(e, v) => v && setSuspModalidad(v)}>
                          <ToggleButton value="ambulatorio">Ambulatorio</ToggleButton>
                          <ToggleButton value="hospitalizacion">Hospitalización</ToggleButton>
                        </ToggleButtonGroup>
                      </Box>
                    </Box>

                    {/* Hasta + No de días */}
                    <Box display="flex" gap={2} alignItems="center">
                      <DatePicker label="Hasta" value={suspHasta} onChange={setSuspHasta}
                        slotProps={{ textField: { size: "small", fullWidth: true } }} />
                      {suspDesde && suspHasta && !suspHasta.startOf("day").isBefore(suspDesde.startOf("day")) && (
                        <Box sx={{ whiteSpace: "nowrap" }}>
                          <Typography variant="caption" color="text.secondary">No de días</Typography>
                          <Typography variant="body2" fontWeight="bold">{suspHasta.startOf("day").diff(suspDesde.startOf("day"), "day") + 1}</Typography>
                        </Box>
                      )}
                      {suspHasta && (
                        <Box sx={{ whiteSpace: "nowrap" }}>
                          <Typography variant="caption" color="text.secondary">Reintegro el</Typography>
                          <Typography variant="body2">{suspHasta.add(1, "day").format("DD/MM/YYYY")}</Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Primero / Sucesivo + Comienzo */}
                    <Box display="flex" gap={2} alignItems="flex-end">
                      <Box>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>Tipo</Typography>
                        <ToggleButtonGroup size="small" exclusive value={suspTipo}
                          onChange={(e, v) => v && setSuspTipo(v)}>
                          <ToggleButton value="primero">Primero</ToggleButton>
                          <ToggleButton value="sucesivo">Sucesivo</ToggleButton>
                        </ToggleButtonGroup>
                      </Box>
                      <DatePicker label="Comienzo del reposo" value={suspComienzo} onChange={setSuspComienzo}
                        slotProps={{ textField: { size: "small", fullWidth: true } }} />
                    </Box>

                    {/* Maternidad */}
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>Maternidad</Typography>
                      <Box display="flex" gap={1} flexWrap="wrap">
                        <DatePicker label="Inicio prenatal" value={suspMatInicioPrenatal} onChange={setSuspMatInicioPrenatal}
                          slotProps={{ textField: { size: "small", sx: { flex: 1, minWidth: 140 } } }} />
                        <DatePicker label="Fin prenatal" value={suspMatFinPrenatal} onChange={setSuspMatFinPrenatal}
                          slotProps={{ textField: { size: "small", sx: { flex: 1, minWidth: 140 } } }} />
                        <DatePicker label="Inicio postnatal" value={suspMatInicioPostnatal} onChange={setSuspMatInicioPostnatal}
                          slotProps={{ textField: { size: "small", sx: { flex: 1, minWidth: 140 } } }} />
                        <DatePicker label="Fin postnatal" value={suspMatFinPostnatal} onChange={setSuspMatFinPostnatal}
                          slotProps={{ textField: { size: "small", sx: { flex: 1, minWidth: 140 } } }} />
                      </Box>
                    </Box>

                    {/* Observación */}
                    <TextField label="Observación" size="small" fullWidth multiline rows={2}
                      value={suspObservacion} onChange={(e) => setSuspObservacion(e.target.value)} />
                  </Box>
                </LocalizationProvider>
              ) : (
                <Typography variant="body2" color="text.secondary">Sin reposo médico.</Typography>
              )
            ) : (() => {
              const sl = visit.suspensionLaboral;
              if (!sl) return (
                <Box sx={{ py: 1.5, textAlign: "center" }}>
                  <Typography variant="body2" color="text.disabled" sx={{ mb: 1.5 }}>Sin reposo médico registrado</Typography>
                  <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: "center" }}>
                    {[
                      { label: "Desde" }, { label: "Hasta" }, { label: "Tipo de reposo" },
                      { label: "Modalidad" }, { label: "Tipo" }, { label: "Observación" },
                    ].map(({ label }) => (
                      <Chip key={label} size="small" variant="outlined" label={label} sx={{ opacity: 0.5 }} />
                    ))}
                  </Box>
                </Box>
              );
              const noDias = sl.desde && sl.hasta ? dayjs(sl.hasta).startOf("day").diff(dayjs(sl.desde).startOf("day"), "day") + 1 : null;
              const hasMat = sl.mat && Object.values(sl.mat).some(Boolean);
              return (
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
                  <InfoRow label="Desde" value={sl.desde ? dayjs(sl.desde).format("DD/MM/YYYY") : null} />
                  <InfoRow label="Hasta" value={sl.hasta ? dayjs(sl.hasta).format("DD/MM/YYYY") : null} />
                  <InfoRow label="No de días" value={noDias != null ? String(noDias) : null} />
                  <InfoRow label="Reintegro el" value={sl.hasta ? dayjs(sl.hasta).add(1, "day").format("DD/MM/YYYY") : null} />
                  <InfoRow label="Debe volver" value={(sl.debeVolver ?? true) ? "Sí" : "No"} />
                  <InfoRow label="Tipo de reposo" value={sl.tipoReposo || null} />
                  <InfoRow label="Modalidad" value={sl.modalidad === "hospitalizacion" ? "Hospitalización" : sl.modalidad === "ambulatorio" ? "Ambulatorio" : null} />
                  <InfoRow label="Tipo" value={sl.tipo === "primero" ? "Primero" : sl.tipo === "sucesivo" ? "Sucesivo" : null} />
                  <InfoRow label="Comienzo del reposo" value={sl.comienzo ? dayjs(sl.comienzo).format("DD/MM/YYYY") : null} />
                  {hasMat && <>
                    <InfoRow label="Inicio prenatal" value={sl.mat.inicioPrenatal ? dayjs(sl.mat.inicioPrenatal).format("DD/MM/YYYY") : null} />
                    <InfoRow label="Fin prenatal" value={sl.mat.finPrenatal ? dayjs(sl.mat.finPrenatal).format("DD/MM/YYYY") : null} />
                    <InfoRow label="Inicio postnatal" value={sl.mat.inicioPostnatal ? dayjs(sl.mat.inicioPostnatal).format("DD/MM/YYYY") : null} />
                    <InfoRow label="Fin postnatal" value={sl.mat.finPostnatal ? dayjs(sl.mat.finPostnatal).format("DD/MM/YYYY") : null} />
                  </>}
                  {sl.observacion && <Box sx={{ gridColumn: "1 / -1" }}><InfoRow label="Observación" value={sl.observacion} /></Box>}
                </Box>
              );
            })()}

            <Box display="flex" gap={1} justifyContent="flex-end" mt="auto" pt={2}>
              {editingSusp ? (
                <>
                  <Button size="small" startIcon={<CancelIcon />} onClick={() => {
                    const sl = visit.suspensionLaboral;
                    setSuspEnabled(!!sl);
                    setSuspDesde(sl?.desde ? dayjs(sl.desde) : null);
                    setSuspHasta(sl?.hasta ? dayjs(sl.hasta) : null);
                    setSuspDebeVolver(sl?.debeVolver ?? true);
                    setSuspTipoReposo(sl?.tipoReposo || "EC");
                    setSuspModalidad(sl?.modalidad || "ambulatorio");
                    setSuspTipo(sl?.tipo || "primero");
                    setSuspComienzo(sl?.comienzo ? dayjs(sl.comienzo) : null);
                    setSuspObservacion(sl?.observacion || "");
                    setEditingSusp(false);
                  }}>Cancelar</Button>
                  <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveSusp} disabled={savingSusp}>
                    Guardar
                  </Button>
                </>
              ) : (
                <Button size="small" startIcon={<EditIcon />} onClick={() => setEditingSusp(true)} disabled={!canEdit}>Editar</Button>
              )}
            </Box>
          </Paper>}

        </Grid>
      </Grid>

      </Box>

      <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <DialogTitle>Eliminar visita</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de que deseas eliminar esta visita? Esta acción no se puede deshacer.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete(false)}>Cancelar</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>Eliminar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmSign} onClose={() => setConfirmSign(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Confirmar firma del paciente</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            ¿Confirmas que el paciente ha firmado el histórico de visita?
          </Typography>
          <Typography variant="body2" color="warning.main">
            Una vez confirmado, la visita quedará bloqueada y solo un administrador podrá modificarla.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmSign(false)}>Cancelar</Button>
          <Button color="success" variant="contained" onClick={handleSign} disabled={signingVisit}>
            {signingVisit ? <CircularProgress size={16} /> : "Confirmar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VisitDetail;
